<script>
import { isCustomDomain, getAccountLogo } from "../utils/helpers";
import { SSO_PROVIDERS } from "../utils/constants";
import AuthShell from "../components/auth/auth-shell.vue";

const { MICROSOFT, GOOGLE } = SSO_PROVIDERS;
export default {
  components: {
    AuthShell,
  },
  data() {
    return {
      username: "",
      password: "",
      working: false,
      rememberMe: false,
      isCustomDomain
    };
  },
  mounted() {
    let self = this;

    let googleSSOMeta = document.createElement("meta");
    googleSSOMeta.name = "google-signin-client_id";
    googleSSOMeta.content = "760818933015-npocie5aurgs406ct2d8fne161dferov.apps.googleusercontent.com";
    document.head.appendChild(googleSSOMeta);

    let googleSSO = document.createElement('script')
    googleSSO.setAttribute('src', 'https://accounts.google.com/gsi/client')
    document.head.appendChild(googleSSO);

    var rememberMeUser = $A.CheckRememberMe();
    if (rememberMeUser) {
      this.rememberMe = true;
      this.username = rememberMeUser;
    }
    if (this.$route.query.h !== undefined) {
      self.$A.UserService.LoginWithToken(this.$route.query.h, false, true);
    }
  },
  computed: {
    accountLogo: function () {
      return getAccountLogo();
    }
  },
  methods: {
    ssoClicked: function(ssoMethod){
      // window.$A.MarketingService.SSOPreSignupEvent();
      const anchor = document.createElement('a');
      anchor.target = '_blank';
      anchor.innerText = 'SSO';
      const currentDomain = window.location.hostname;
      if(ssoMethod === GOOGLE){
        anchor.href = `${window.$A.Env.apiHost}/login/sso/${GOOGLE}?domain=${currentDomain}`;
      }

      if(ssoMethod === MICROSOFT){
        anchor.href = `${window.$A.Env.apiHost}/login/sso/${MICROSOFT}?domain=${currentDomain}`;
      }
      document.body.appendChild(anchor);
      anchor.click();
    },
    async LogIn() {
      if (this.rememberMe) {
        $A.SetRememberMe(this.username);
      }
      this.working = true;
      await $A.UserService.Login(this.username, this.password);
      this.working = false;
    },
  },
};
</script>

<style scoped>
.account-logo {
  width: 50px;
  height: 50px;
}

.remember-me-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 13px;
  color: #4b5563;
}
</style>

<template>
  <auth-shell :show-panel="!isCustomDomain">
    <div v-if="accountLogo" class="auth-logo">
      <img :src="accountLogo" :class="{ 'account-logo': !isCustomDomain }"/>
    </div>

    <h4 class="auth-title">{{isCustomDomain ? 'Login' : 'Login to Ashore'}}</h4>
    <p class="auth-subtitle">Welcome back. Sign in to your account.</p>

    <!-- Google Btn -->
    <div class="form-group">
      <button type="button" class="auth-btn-ghost" @click="ssoClicked('google')">
        <img src="/img/google-icon.svg" width="18" height="18"/>
        Sign in with Google
      </button>
    </div>

    <!-- Microsoft Btn -->
    <div class="form-group">
      <button type="button" class="auth-btn-ghost" @click="ssoClicked('microsoft')">
        <img src="/img/microsoft-icon.svg" width="18" height="18"/>
        Sign in with Microsoft
      </button>
    </div>

    <div class="auth-divider">Or</div>

    <div class="form-group">
      <label class="auth-label">Your Email</label>
      <input
          type="text"
          name="Username"
          class="auth-field"
          v-model="username"
      />
    </div>
    <div class="form-group">
      <label class="auth-label">Your Password</label>
      <input
          type="password"
          name="Password"
          class="auth-field"
          v-model="password"
          v-on:keyup.enter="LogIn()"
      />
    </div>
    <div class="ashore-toggle remember-me-row">
      <label class="switch">
        <input type="checkbox" v-model="rememberMe"/>
        <span class="slider round"></span>
      </label>
      Remember Me
    </div>
    <button
        v-on:click="LogIn()"
        data-cy="LogInBtn"
        class="auth-btn-primary mt-3">
      <b-spinner
          variant="light"
          v-show="working"
          type="grow"
          small
      ></b-spinner>
      Login
    </button>
    <a href="/forgot-password" class="auth-btn-ghost my-3">
      Forgot My Password
    </a>
    <a v-if="!isCustomDomain" href="/sign-up" class="auth-btn-ghost">
      Create an Account
    </a>
  </auth-shell>
</template>
